import { httpRequest } from "../../utils/httpRequest";

// ساخت درفت اولیه‌ی آزمون
export async function createExamDraft(
  token,
  { categoryId, titleFa, descFa, timeMode, totalTime },
) {
  const payload = {
    category: categoryId,
    title: { fa: titleFa || "", en: "" },
    description: descFa ? { fa: descFa, en: "" } : undefined,
    isPublished: false,
    sections: [], // ابتدا خالی؛ بعداً با PUT پر می‌کنیم
  };
  return httpRequest("POST", "/exam", payload, { "x-access-token": token });
}

// به‌روزرسانی آزمون (فقط فیلدهایی که می‌فرستی به‌روز می‌شود)
export async function updateExam(token, examId, partialPayload) {
  return httpRequest("PUT", `/exam/${examId}`, partialPayload, {
    "x-access-token": token,
  });
}
